import { meses } from "./meses";

/**
 * FUNCIÓN QUE RETORNA LA FECHA ACTUAL
 * @returns STRING DE FECHA EN FORMATO DD/MM/YYYY
 */
const fechaActual = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1;
    let dd = today.getDate();

    if (dd < 10) dd = '0' + dd;

    return `${dd} / ${meses[mm]} / ${yyyy}`;

}

export default fechaActual;